import type { Translatable } from "app/pages/sales-intelligence/types";
import { ACTION_PANEL_DROPDOWN_VALUE_ALL } from "../../../constants";
import SelectionItem from "../SelectionItem";

export default class AllDropdownItem extends SelectionItem {
    static ID = ACTION_PANEL_DROPDOWN_VALUE_ALL;

    constructor(value: number, disabledReason?: Readonly<Translatable>, i18nKeyModifier?: string) {
        super(AllDropdownItem.ID, AllDropdownItem.ID, value, disabledReason, i18nKeyModifier);
    }

    getSelectedTranslation() {
        return {
            key: `si.${this.translationKeyModifier}.options.all.selected_text`,
            replacements: {
                numberOfItems: this.formatValue(),
            },
        };
    }

    getTranslation() {
        return {
            key: `si.${this.translationKeyModifier}.options.all`,
            replacements: {
                numberOfItems: this.formatValue(),
            },
        };
    }
}
